import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookie-consent';

const texts = {
  de: {
    message:
      'Wir verwenden Cookies und Google Analytics, um diese Website zu verbessern. Deine Daten werden anonymisiert erfasst.',
    accept: 'Akzeptieren',
    reject: 'Ablehnen',
  },
  en: {
    message:
      'We use cookies and Google Analytics to improve this website. Your data is collected anonymously.',
    accept: 'Accept',
    reject: 'Decline',
  },
};

// Use the global gtag function defined in index.html
function gtag(..._args: any[]) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  (window as any).dataLayer.push(arguments);
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'de';
  const t = texts[lang];

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (visible) {
      document.body.classList.add('has-cookie-banner');
    } else {
      document.body.classList.remove('has-cookie-banner');
    }
    return () => {
      document.body.classList.remove('has-cookie-banner');
    };
  }, [visible]);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    gtag('consent', 'update', {
      'analytics_storage': 'granted',
    });
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-inner">
        <p className="cookie-consent-text">{t.message}</p>
        <div className="cookie-consent-actions">
          <button className="cookie-consent-btn cookie-consent-btn--primary" onClick={accept}>
            {t.accept}
          </button>
          <button className="cookie-consent-btn cookie-consent-btn--secondary" onClick={reject}>
            {t.reject}
          </button>
        </div>
      </div>
    </div>
  );
}
